import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { FetchSubModule } from "./HyperLink/FetchSubModule";
import { decodeHTML } from "~/Utils/CommonUtils";

export const getPopupDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  cameraAccess: [
    {
      fieldName: "Access Permission (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Access Permission (EN)",
      placeholder: "Enter name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Access Permission (MS)",
      fieldValue: "field_access_permission_ms",
      name: "field_access_permission_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Access Permission (MS)",
      placeholder: "Enter access permission (MS)",
      // validation: { required: "Access Permission (MS) is required" },
    },
    {
      fieldName: "Access Permission (ZH)",
      fieldValue: "field_access_permission_zh",
      name: "field_access_permission_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Access Permission (ZH)",
      placeholder: "Enter access permission (ZH)",
      // validation: { required: "Access Permission (ZH) is required" },
    },
    {
      fieldName: "Allow Button (EN)",
      fieldValue: "field_allow_btn_en",
      name: "field_allow_btn_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Allow Button (EN)",
      placeholder: "Enter allow button (EN)",
      validation: { required: "Allow Button (EN) is required" },
    },
    {
      fieldName: "Allow Button (MS)",
      fieldValue: "field_allow_btn_ms",
      name: "field_allow_btn_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Allow Button (MS)",
      placeholder: "Enter allow button (MS)",
      // validation: { required: "Allow Button (MS) is required" },
    },
    {
      fieldName: "Allow Button (ZH)",
      fieldValue: "field_allow_btn_zh",
      name: "field_allow_btn_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Allow Button (ZH)",
      placeholder: "Enter allow button (ZH)",
      // validation: { required: "Allow Button (ZH) is required" },
    },
    {
      fieldName: "Cancel Button (EN)",
      fieldValue: "field_cancel_btn_en",
      name: "field_cancel_btn_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Cancel Button (EN)",
      placeholder: "Enter cancel button (EN)",
      validation: { required: "Cancel Button (EN) is required" },
    },
    {
      fieldName: "Cancel Button (MS)",
      fieldValue: "field_cancel_btn_ms",
      name: "field_cancel_btn_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Cancel Button (MS)",
      placeholder: "Enter cancel button (MS)",
      // validation: { required: "Cancel Button (MS) is required" },
    },
    {
      fieldName: "Cancel Button (ZH)",
      fieldValue: "field_cancel_btn_zh",
      name: "field_cancel_btn_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Cancel Button (ZH)",
      placeholder: "Enter cancel button (ZH)",
      // validation: { required: "Cancel Button (ZH) is required" },
    },
    {
      fieldName: "Confirm Text (EN)",
      fieldValue: "field_confirm_text_en",
      name: "field_confirm_text_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Confirm Text (EN)",
      placeholder: "Enter confirm text (EN)",
      validation: { required: "Confirm Text (EN) is required" },
    },
    {
      fieldName: "Confirm Text (MS)",
      fieldValue: "field_confirm_text_ms",
      name: "field_confirm_text_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Confirm Text (MS)",
      placeholder: "Enter confirm text (MS)",
      // validation: { required: "Confirm Text (MS) is required" },
    },
    {
      fieldName: "Confirm Text (ZH)",
      fieldValue: "field_confirm_text_zh",
      name: "field_confirm_text_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Confirm Text (ZH)",
      placeholder: "Enter confirm text (ZH)",
      // validation: { required: "Confirm Text (ZH) is required" },
    },
  ],
  loginPopUp: [
    {
      fieldName: "Login Image",
      fieldValue: "field_login_image",
      className: "col-span-6",
      type: "image",
      name: "field_login_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Login Image",
      placeholder: "",
      validation: { required: "Login Image is required" },
    },
    {
      fieldName: "Login Text (EN)",
      fieldValue: "field_login_text",
      className: "col-span-6",
      type: "text",
      name: "field_login_text",
      formType: "input",
      label: "Login Text (EN)",
      placeholder: "Enter login text",
      validation: { required: "Login Text is required" },
    },
    {
      fieldName: "Login Text (MS)",
      fieldValue: "field_login_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_text_ms",
      formType: "input",
      label: "Login Text (MS)",
      placeholder: "Enter login text in MS",
      // validation: { required: "Login Text (MS) is required" },
    },
    {
      fieldName: "Login Text (ZH)",
      fieldValue: "field_login_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_text_zh",
      formType: "input",
      label: "Login Text (ZH)",
      placeholder: "Enter login text in ZH",
      // validation: { required: "Login Text (ZH) is required" },
    },
    {
      fieldName: "Login Email Text (EN)",
      fieldValue: "field_login_email_text",
      className: "col-span-6",
      type: "text",
      name: "field_login_email_text",
      formType: "input",
      label: "Login Email Text (EN)",
      placeholder: "Enter login email text",
      validation: { required: "Login Email Text is required" },
    },
    {
      fieldName: "Login Email Text (MS)",
      fieldValue: "field_login_email_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_email_text_ms",
      formType: "input",
      label: "Login Email Text (MS)",
      placeholder: "Enter login email text in MS",
      // validation: { required: "Login Email Text (MS) is required" },
    },
    {
      fieldName: "Login Email Text (ZH)",
      fieldValue: "field_login_email_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_email_text_zh",
      formType: "input",
      label: "Login Email Text (ZH)",
      placeholder: "Enter login email text in ZH",
      // validation: { required: "Login Email Text (ZH) is required" },
    },
    {
      fieldName: "Login Password (EN)",
      fieldValue: "field_login_password",
      className: "col-span-6",
      type: "text",
      name: "field_login_password",
      formType: "input",
      label: "Login Password (EN)",
      placeholder: "Enter login password",
      validation: { required: "Login Password is required" },
    },
    {
      fieldName: "Login Password (MS)",
      fieldValue: "field_login_password_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_password_ms",
      formType: "input",
      label: "Login Password (MS)",
      placeholder: "Enter login password in MS",
      // validation: { required: "Login Password (MS) is required" },
    },
    {
      fieldName: "Login Password (ZH)",
      fieldValue: "field_login_password_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_password_zh",
      formType: "input",
      label: "Login Password (ZH)",
      placeholder: "Enter login password in ZH",
      // validation: { required: "Login Password (ZH) is required" },
    },
    {
      fieldName: "Forgot Password Text (EN)",
      fieldValue: "field_forgot_password",
      className: "col-span-6",
      type: "text",
      name: "field_forgot_password",
      formType: "input",
      label: "Forgot Password Text (EN)",
      placeholder: "Enter forgot password text",
      validation: { required: "Forgot Password Text is required" },
    },
    {
      fieldName: "Forgot Password Text (MS)",
      fieldValue: "field_forgot_password_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_forgot_password_text_ms",
      formType: "input",
      label: "Forgot Password Text (MS)",
      placeholder: "Enter forgot password text in MS",
      // validation: { required: "Forgot Password Text (MS) is required" },
    },
    {
      fieldName: "Forgot Password Text (ZH)",
      fieldValue: "field_forgot_password_text_zn",
      className: "col-span-6",
      type: "text",
      name: "field_forgot_password_text_zn",
      formType: "input",
      label: "Forgot Password Text (ZH)",
      placeholder: "Enter forgot password text in ZH",
      // validation: { required: "Forgot Password Text (ZH) is required" },
    },
    {
      fieldName: "Show Image",
      fieldValue: "field_login_show_image",
      className: "col-span-6",
      type: "image",
      name: "field_login_show_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Show Image",
      placeholder: "",
      validation: { required: "Show Image is required" },
    },
    {
      fieldName: "Login Button Text (EN)",
      fieldValue: "field_login_button_text",
      className: "col-span-6",
      type: "text",
      name: "field_login_button_text",
      formType: "input",
      label: "Login Button Text (EN)",
      placeholder: "Enter login button text",
      validation: { required: "Login Button Text is required" },
    },
    {
      fieldName: "Login Button Text (MS)",
      fieldValue: "field_login_button_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_button_text_ms",
      formType: "input",
      label: "Login Button Text (MS)",
      placeholder: "Enter login button text in MS",
      // validation: { required: "Login Button Text (MS) is required" },
    },
    {
      fieldName: "Login Button Text (ZH)",
      fieldValue: "field_login_button_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_button_text_zh",
      formType: "input",
      label: "Login Button Text (ZH)",
      placeholder: "Enter login button text in ZH",
      // validation: { required: "Login Button Text (ZH) is required" },
    },
    {
      fieldName: "Or Text (EN)",
      fieldValue: "field_login_or_text",
      className: "col-span-6",
      type: "text",
      name: "field_login_or_text",
      formType: "input",
      label: "Or Text (EN)",
      placeholder: "Enter 'Or' text",
      validation: { required: "'Or' Text is required" },
    },
    {
      fieldName: "Or Text (MS)",
      fieldValue: "field_login_or_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_login_or_text_ms",
      formType: "input",
      label: "Or Text (MS)",
      placeholder: "Enter 'Or' text in MS",
      // validation: { required: "'Or' Text (MS) is required" },
    },
    {
      fieldName: "Or Text (ZH)",
      fieldValue: "field_login_or_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_login_or_text_zh",
      formType: "input",
      label: "Or Text (ZH)",
      placeholder: "Enter 'Or' text in ZH",
      // validation: { required: "'Or' Text (ZH) is required" },
    },
    {
      fieldName: "Facebook Text (EN)",
      fieldValue: "field_facebook_text",
      className: "col-span-6",
      type: "text",
      name: "field_facebook_text",
      formType: "input",
      label: "Facebook Text (EN)",
      placeholder: "Enter Facebook text",
      validation: { required: "Facebook Text is required" },
    },
    {
      fieldName: "Facebook Text (MS)",
      fieldValue: "field_facebook_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_facebook_text_ms",
      formType: "input",
      label: "Facebook Text (MS)",
      placeholder: "Enter Facebook text in MS",
      // validation: { required: "Facebook Text (MS) is required" },
    },
    {
      fieldName: "Facebook Text (ZH)",
      fieldValue: "field_facebook_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_facebook_text_zh",
      formType: "input",
      label: "Facebook Text (ZH)",
      placeholder: "Enter Facebook text in ZH",
      // validation: { required: "Facebook Text (ZH) is required" },
    },
    {
      fieldName: "Facebook Image",
      fieldValue: "field_facebook_image",
      className: "col-span-6",
      type: "image",
      name: "field_facebook_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Facebook Image",
      placeholder: "",
      validation: { required: "Facebook Image is required" },
    },
    {
      fieldName: "Google Image",
      fieldValue: "field_google_image",
      className: "col-span-6",
      type: "image",
      name: "field_google_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Google Image",
      placeholder: "",
      validation: { required: "Google Image is required" },
    },
    {
      fieldName: "Google Text (EN)",
      fieldValue: "field_google_text",
      className: "col-span-6",
      type: "text",
      name: "field_google_text",
      formType: "input",
      label: "Google Text (EN)",
      placeholder: "Enter Google text",
      validation: { required: "Google Text is required" },
    },
    {
      fieldName: "Google Text (MS)",
      fieldValue: "field_google_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_google_text_ms",
      formType: "input",
      label: "Google Text (MS)",
      placeholder: "Enter Google text in MS",
      // validation: { required: "Google Text (MS) is required" },
    },
    {
      fieldName: "Google Text (ZH)",
      fieldValue: "field_google_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_google_text_zh",
      formType: "input",
      label: "Google Text (ZH)",
      placeholder: "Enter Google text in ZH",
      // validation: { required: "Google Text (ZH) is required" },
    },
    {
      fieldName: "Register Now Text (EN)",
      fieldValue: "field_register_now_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_register_now_text_en",
      formType: "input",
      label: "Register Now Text (EN)",
      placeholder: "Enter 'Register Now' text in EN",
      validation: { required: "'Register Now' Text (EN) is required" },
    },
    {
      fieldName: "Register Now Text (MS)",
      fieldValue: "field_register_now_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_register_now_text_ms",
      formType: "input",
      label: "Register Now Text (MS)",
      placeholder: "Enter 'Register Now' text in MS",
      // validation: { required: "'Register Now' Text (MS) is required" },
    },
    {
      fieldName: "Register Now Text (ZH)",
      fieldValue: "field_register_now_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_register_now_text_zh",
      formType: "input",
      label: "Register Now Text (ZH)",
      placeholder: "Enter 'Register Now' text in ZH",
      // validation: { required: "'Register Now' Text (ZH) is required" },
    },
    {
      fieldName: "Register Now Button (EN)",
      fieldValue: "field_register_now_button",
      className: "col-span-6",
      type: "text",
      name: "field_register_now_button",
      formType: "input",
      label: "Register Now Button (EN)",
      placeholder: "Enter 'Register Now' button text",
      validation: { required: "'Register Now' Button is required" },
    },
    {
      fieldName: "Register Now Button (MS)",
      fieldValue: "field_register_now_button_ms",
      className: "col-span-6",
      type: "text",
      name: "field_register_now_button_ms",
      formType: "input",
      label: "Register Now Button (MS)",
      placeholder: "Enter 'Register Now' button text in MS",
      // validation: { required: "'Register Now' Button (MS) is required" },
    },
    {
      fieldName: "Register Now Button (ZH)",
      fieldValue: "field_register_now_button_zh",
      className: "col-span-6",
      type: "text",
      name: "field_register_now_button_zh",
      formType: "input",
      label: "Register Now Button (ZH)",
      placeholder: "Enter 'Register Now' button text in ZH",
      // validation: { required: "'Register Now' Button (ZH) is required" },
    },
    {
      fieldName: "Filled Image",
      fieldValue: "field_login_filled_image",
      className: "col-span-6",
      type: "image",
      name: "field_login_filled_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Filled Image",
      placeholder: "",
      validation: { required: "Filled Image is required" },
    },
    {
      fieldName: "Web Login Icon",
      fieldValue: "field_web_login_icon",
      className: "col-span-6",
      type: "image",
      usedFileType: 'image/*',
      name: "field_web_login_icon",
      formType: "file",
      label: "Web Login Icon",
      placeholder: "",
      validation: { required: "Web Login Icon is required" },
    },
    {
      fieldName: "Web Login Image",
      fieldValue: "field_web_login_image",
      className: "col-span-6",
      type: "image",
      usedFileType: 'image/*',
      name: "field_web_login_image",
      formType: "file",
      label: "Web Login Image",
      placeholder: "",
      validation: { required: "Web Login Image is required" },
    },
    {
      fieldName: "Apple Text (EN)",
      fieldValue: "field_apple_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_apple_text_en",
      formType: "input",
      label: "Apple Text (EN)",
      placeholder: "Enter Apple text in EN",
      validation: { required: "Apple Text (EN) is required" },
    },
    {
      fieldName: "Apple Text (MS)",
      fieldValue: "field_apple_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_apple_text_ms",
      formType: "input",
      label: "Apple Text (MS)",
      placeholder: "Enter Apple text in MS",
      // validation: { required: "Apple Text (MS) is required" },
    },
    {
      fieldName: "Apple Text (ZH)",
      fieldValue: "field_apple_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_apple_text_zh",
      formType: "input",
      label: "Apple Text (ZH)",
      placeholder: "Enter Apple text in ZH",
      // validation: { required: "Apple Text (ZH) is required" },
    },
    {
      fieldName: "Apple Image",
      fieldValue: "field_apple_image",
      className: "col-span-6",
      type: "image",
      name: "field_apple_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Apple Image",
      placeholder: "",
      validation: { required: "Apple Image is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Published",
    },
  ],
  languagePopUp: [
    {
      fieldName: "Language (EN)",
      fieldValue: "field_language_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Language (EN)",
      placeholder: "Enter name",
      validation: { required: "Name is required" },
      name: "field_language_en",
    },
    {
      fieldName: "Language (MS)",
      fieldValue: "field_language_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Language (MS)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_language_ms",
    },
    {
      fieldName: "Language (ZH)",
      fieldValue: "field_language_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Language (ZH)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_language_zh",
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter name",
      validation: { required: "Name is required" },
      name: "name",
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_name_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_name_ms",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_name_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_name_zh",
    },
    {
      fieldName: "Bahasa (EN)",
      fieldValue: "field_bhasha_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Bahasa (EN)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_bhasha_en",
    },
    {
      fieldName: "Bahasa (MS)",
      fieldValue: "field_bhasha_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Bahasa (MS)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_bhasha_ms",
    },
    {
      fieldName: "Bahasa (ZH)",
      fieldValue: "field_bhasha_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Bahasa (ZH)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_bhasha_zh",
    },
    {
      fieldName: "Mandarin (EN)",
      fieldValue: "field_mandrain_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Mandarin (EN)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_mandrain_en",
    },
    {
      fieldName: "Mandarin (MS)",
      fieldValue: "field_mandrain_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Mandarin (MS)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_mandrain_ms",
    },
    {
      fieldName: "Mandarin (ZH)",
      fieldValue: "field_mandrain_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Mandarin (ZH)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_mandrain_zh",
    },
    {
      fieldName: "Continue (EN)",
      fieldValue: "field_continue_en",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Continue (EN)",
      placeholder: "Enter name",
      validation: { required: "Name is required" },
      name: "field_continue_en",
    },
    {
      fieldName: "Continue (MS)",
      fieldValue: "field_continue_ms",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Continue (MS)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_continue_ms",
    },
    {
      fieldName: "Continue (ZH)",
      fieldValue: "field_continue_zh",
      className: "col-span-6",
      type: "text",
      formType: "input",
      label: "Continue (ZH)",
      placeholder: "Enter name",
      // validation: { required: "Name is required" },
      name: "field_continue_zh",
    },
  ],
  purchaseLoginPopUp: [
    {
      fieldName: "Purchase Login Pop Image",
      fieldValue: "field_purchase_login_pop_image",
      className: "col-span-6",
      type: "image",
      name: "field_purchase_login_pop_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Purchase Login Pop Image",
      placeholder: "",
      validation: { required: "Purchase Login Pop Image is required" },
    },
    {
      fieldName: "Purchase Text (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Purchase Text (EN)",
      placeholder: "Enter Purchase Text (EN)",
      validation: { required: "Purchase Text (EN) is required" },
    },
    {
      fieldName: "Purchase Text (MS)",
      fieldValue: "field_purchase_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_text_ms",
      formType: "input",
      label: "Purchase Text (MS)",
      placeholder: "Enter purchase text (MS)",
      // validation: { required: "Purchase Text (MS) is required" },
    },
    {
      fieldName: "Purchase Text (ZH)",
      fieldValue: "field_purchase_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_text_zh",
      formType: "input",
      label: "Purchase Text (ZH)",
      placeholder: "Enter purchase text (ZH)",
      // validation: { required: "Purchase Text (ZH) is required" },
    },
    {
      fieldName: "Purchase Login Pop Button (EN)",
      fieldValue: "field_purchase_login_pop_button",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_login_pop_button",
      formType: "input",
      label: "Purchase Login Pop Button (EN)",
      placeholder: "Enter button text (EN)",
      validation: { required: "Purchase Login Pop Button (EN) is required" },
    },
    {
      fieldName: "Purchase Login Button (MS)",
      fieldValue: "field_purchase_login_button_ms",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_login_button_ms",
      formType: "input",
      label: "Purchase Login Button (MS)",
      placeholder: "Enter button text (MS)",
      // validation: { required: "Purchase Login Button (MS) is required" },
    },
    {
      fieldName: "Purchase Login Button (ZH)",
      fieldValue: "field_purchase_login_button_zh",
      className: "col-span-6",
      type: "text",
      name: "field_purchase_login_button_zh",
      formType: "input",
      label: "Purchase Login Button (ZH)",
      placeholder: "Enter button text (ZH)",
      // validation: { required: "Purchase Login Button (ZH) is required" },
    },
  ],
  logoutPopUp: [
    {
      fieldName: "Logout Image",
      fieldValue: "field_logout_image",
      className: "col-span-6",
      type: "image",
      name: "field_logout_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Logout Image",
      placeholder: "",
      validation: { required: "Logout Image is required" },
    },
    {
      fieldName: "Logout Text (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Logout Text (EN)",
      placeholder: "Enter Logout Text (EN)",
      validation: { required: "Logout Text (EN) is required" },
    },
    {
      fieldName: "Logout Text (MS)",
      fieldValue: "field_logout_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_logout_txt_ms",
      formType: "input",
      label: "Logout Text (MS)",
      placeholder: "Enter logout text (MS)",
      // validation: {},
    },
    {
      fieldName: "Logout Text (ZH)",
      fieldValue: "field_logout_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_logout_txt_zh",
      formType: "input",
      label: "Logout Text (ZH)",
      placeholder: "Enter logout text (ZH)",
      // validation: {},
    },
    {
      fieldName: "No Text (EN)",
      fieldValue: "field_no_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_no_text_en",
      formType: "input",
      label: "No Text (EN)",
      placeholder: "Enter no text (EN)",
      validation: { required: "Text (EN) is required" },
    },
    {
      fieldName: "No Text (MS)",
      fieldValue: "field_no_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_no_text_ms",
      formType: "input",
      label: "No Text (MS)",
      placeholder: "Enter no text (MS)",
      // validation: {},
    },
    {
      fieldName: "No Text (ZH)",
      fieldValue: "field_no_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_no_text_zh",
      formType: "input",
      label: "No Text (ZH)",
      placeholder: "Enter no text (ZH)",
      // validation: {},
    },
    {
      fieldName: "Yes Confirm Text (EN)",
      fieldValue: "field_yes_confirm_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_yes_confirm_text_en",
      formType: "input",
      label: "Yes Confirm Text (EN)",
      placeholder: "Enter yes confirm text (EN)",
      validation: { required: "Yes Confirm text (EN) is required" },
    },
    {
      fieldName: "Yes Confirm Text (MS)",
      fieldValue: "field_yes_confirm_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_yes_confirm_txt_ms",
      formType: "input",
      label: "Yes Confirm Text (MS)",
      placeholder: "Enter yes confirm text (MS)",
      // validation: {},
    },
    {
      fieldName: "Yes Confirm Text (ZH)",
      fieldValue: "field_yes_confirm_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_yes_confirm_txt_zh",
      formType: "input",
      label: "Yes Confirm Text (ZH)",
      placeholder: "Enter yes confirm text (ZH)",
      // validation: {},
    },
  ],
  VMSPopUp: [
    {
      fieldName: "Continue Text (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Continue Text (EN)",
      placeholder: "Enter Continue Text (EN)",
      validation: { required: "Continue Text (EN) is required" },
    },
    {
      fieldName: "Continue Text (MS)",
      fieldValue: "field_continue_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_continue_text_ms",
      formType: "input",
      label: "Continue Text (MS)",
      placeholder: "Enter continue text (MS)",
      // validation: { required: "Continue Text (MS) is required" },
    },
    {
      fieldName: "Continue Text (ZH)",
      fieldValue: "field_continue_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_continue_text_zh",
      formType: "input",
      label: "Continue Text (ZH)",
      placeholder: "Enter continue text (ZH)",
      // validation: { required: "Continue Text (ZH) is required" },
    },
    {
      fieldName: "VMS Text (EN)",
      fieldValue: "field_vms_text",
      className: "col-span-6",
      type: "textarea",
      name: "field_vms_text",
      formType: "textarea",
      label: "VMS Text (EN)",
      placeholder: "Enter VMS text (EN)",
      validation: { required: "VMS Text (EN) is required" },
    },
    {
      fieldName: "VMS Text (MS)",
      fieldValue: "field_vms_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_vms_text_ms",
      formType: "input",
      label: "VMS Text (MS)",
      placeholder: "Enter VMS text (MS)",
      // validation: { required: "VMS Text (MS) is required" },
    },
    {
      fieldName: "VMS Text (ZH)",
      fieldValue: "field_vms_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_vms_text_zh",
      formType: "input",
      label: "VMS Text (ZH)",
      placeholder: "Enter VMS text (ZH)",
      // validation: { required: "VMS Text (ZH) is required" },
    },
    {
      fieldName: "VMS Button (EN)",
      fieldValue: "field_vms_button",
      className: "col-span-6",
      type: "text",
      name: "field_vms_button",
      formType: "input",
      label: "VMS Button (EN)",
      placeholder: "Enter VMS button text (EN)",
      validation: { required: "VMS Button (EN) is required" },
    },
    {
      fieldName: "VMS Button (MS)",
      fieldValue: "field_vms_button_ms",
      className: "col-span-6",
      type: "text",
      name: "field_vms_button_ms",
      formType: "input",
      label: "VMS Button (MS)",
      placeholder: "Enter VMS button text (MS)",
      // validation: { required: "VMS Button (MS) is required" },
    },
    {
      fieldName: "VMS Button (ZH)",
      fieldValue: "field_vms_button_zh",
      className: "col-span-6",
      type: "text",
      name: "field_vms_button_zh",
      formType: "input",
      label: "VMS Button (ZH)",
      placeholder: "Enter VMS button text (ZH)",
      // validation: { required: "VMS Button (ZH) is required" },
    },
  ],
  hyperLinkPopUp:[
    {
      fieldName: "ID",
      fieldValue: "id",
      className: "col-span-6",
      type: "text",
      name: "id",
      formType: "input",
      label: "ID",
      placeholder: "Enter ID",
      // validation: { required: "ID is required" },
      hidden: true
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "field_hyperlink_name_en",
      className: "col-span-6",
      type: "text",
      name: "field_hyperlink_name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_hyperlink_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_hyperlink_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Malay Name",
      // validation: { required: "Malay Name is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_hyperlink_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_hyperlink_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Mandarin Name",
      // validation: { required: "Mandarin Name is required" },
    },
    {
          fieldName: "Module",
          fieldValue: "field_module",
          className: "col-span-6",
          type: "select",
          name: "field_module",
          formType: "select",
          label: "Module",
          placeholder: "Enter Module",
          validation: { required: "Module is required" },
          options: [
            {
              label: "Introduction",
              value: "Introduction"
            },
            {
              label: "Procurement Planning",
              value: "Procurement Planning"
            },
            {
              label: "Requisition",
              value: "Requisition"
            },
            {
              label: "Sourcing",
              value: "Sourcing"
            },
            {
              label: "Contract Administration",
              value: "Contract Administration"
            },
            {
              label: "Vendor Management",
              value: "Vendor Management"
            },
            // {
            //   label: "Announcement",
            //   value: "ANNOUNCEMENT"
            // },
            // {
            //   label: "Manual",
            //   value: "Manual"
            // },
            // {
            //   label: "FAQ",
            //   value: "FAQ"
            // },
            // {
            //   label: "PopUp",
            //   value: "POPUP"
            // },
            // {
            //   label: "Login",
            //   value: "LOGIN"
            // },
            // {
            //   label: "Profile",
            //   value: "PROFILE"
            // },
            // {
            //   label: "Others",
            //   value: "OTHERS"
            // },
            // {
            //   label: "Gallery",
            //   value: "Gallery"
            // },
            // {
            //   label: "Contact Directory",
            //   value: "Contact Directory"
            // },
          ]
    },
    {
      fieldName: "Sub Module",
      fieldValue: "field_sub_module",
      className: "col-span-6",
      type: "text", //select
      name: "field_sub_module",
      formType: "select",
      label: "Sub Module",
      placeholder: "Enter Sub Module",
      validation: { required: "Sub Module is required" },
      loadOptions: FetchSubModule
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_hyperlink_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_hyperlink_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_hyperlink_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_hyperlink_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Malay Description is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_hyperlink_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_hyperlink_description_zh",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Mandarin Description is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "field_hyperlink_published",
      className: "col-span-12",
      type: "checkbox",
      name: "field_hyperlink_published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      validation: { required: "Published is required" },
    },
  ],
  welcomeBanner:[
    {
      fieldName: "Mobile Popup Image",
      fieldValue: "field_banner_popup_image",
      className: "col-span-6",
      type: "image",
      name: "field_banner_popup_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Mobile Popup Image",
      placeholder: "Select Banner Popup Image",
      validation: { required: "Banner Popup Image is required" },
      note: "Upload image below 350 x 313 pixel"
    },
    {
      fieldName: "Web Popup Image",
      fieldValue: "field_web_popup",
      className: "col-span-6",
      type: "image",
      name: "field_web_popup",
      formType: "file",
      usedFileType: 'image/*',
      label: "Web Popup Image",
      placeholder: "Select Web Popup Image",
      validation: { required: "Web Popup Image is required",
        // validate: async (files) => {
        //   console.log("filesss", files);
        //   const MAX_WIDTH = 1110;
        //   const MAX_HEIGHT = 489;
        //   const validateImageSize = async (file: File): Promise<boolean> => {
        //     return new Promise((resolve) => {
        //       const img = new Image();
        //       img.src = URL.createObjectURL(file);
        //       img.onload = () => {
        //         const isValidSize = img.width <= MAX_WIDTH && img.height <= MAX_HEIGHT;
        //         resolve(isValidSize);
        //       };
        //     });
        //   };
        //   if (!files || files.length === 0) return "Web Popup Image is required";
        //   const file = files[0];
        //   const isValidSize = await validateImageSize(file);
        //   console.log("filesss isvalidsie" , isValidSize);
        //   return isValidSize || `Image must be ${MAX_WIDTH} x ${MAX_HEIGHT} pixels or below`;
        // },
       },
       note: "Upload image below 1110 x 489 pixel"
    },
    // {
    //   fieldName: "Redirected URL",
    //   fieldValue: "field_redirect_url",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_redirect_url",
    //   formType: "input",
    //   label: "Redirected URL",
    //   placeholder: "Enter Redirected URL",
    //   validation: { required: "Redirected URL is required" },
    // },
    {
      fieldName: "Image Text (EN)",
      fieldValue: "field_image_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_image_text_en",
      formType: "input",
      label: "Image Text (EN)",
      placeholder: "Enter Image Text (EN)",
      validation: { 
        // required: "Image Text (EN) is required", 
        maxLength: { value: 20, message: "Image Text (EN) must be at most 20 characters" } 
      },
      note: "Image Text (EN) must not exceed 20 characters"     
    },
    {
      fieldName: "Image Text (MS)",
      fieldValue: "field_image_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_image_text_ms",
      formType: "input",
      label: "Image Text (MS)",
      placeholder: "Enter Image Text (MS)",
      // validation: { required: "Image Text is required" },
      validation: { 
        // required: "Image Text (EN) is required", 
        maxLength: { value: 20, message: "Image Text (EN) must be at most 20 characters" } 
      },
      note: "Image Text (MS) must not exceed 20 characters"     
    },
    {
      fieldName: "Image Text (ZH)",
      fieldValue: "field_image_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_image_text_zh",
      formType: "input",
      label: "Image Text (ZH)",
      placeholder: "Enter Image Text (ZH)",
      // validation: { required: "Image Text is required" },
      validation: { 
        // required: "Image Text (EN) is required", 
        maxLength: { value: 20, message: "Image Text (EN) must be at most 20 characters" } 
      },
      note: "Image Text (ZH) must not exceed 20 characters"     
    },
    {
      fieldName: "Image Text Color",
      fieldValue: "field_title_color",
      className: "col-span-6",
      type: "text",
      name: "field_title_color",
      formType: "color",
      label: "Image Text Color",
      placeholder: "Enter Image Text Color",
      validation: { required: "Image Text Color is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_banner_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_banner_description_en",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { 
        // required: "Description (EN) is required",
        validate: (value: string) => {
                const removeHtmlTags = (input: string) => {
                  const doc = new DOMParser().parseFromString(input, "text/html");
                  return doc.body.textContent || "";
                };
                const decodedValue = decodeHTML(value);
                const cleanedValue = removeHtmlTags(decodedValue);      
                return cleanedValue.length <= 250 || "Description (EN) must be at most 250 characters";
              },        
              // maxLength: 250,
      },
      note: "Description (EN) must not exceed 250 characters"
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_banner_description_mal",
      className: "col-span-6",
      type: "text",
      name: "field_banner_description_mal",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Malay Description is required" },
      validation: { 
        validate: (value: string) => {
          const removeHtmlTags = (input: string) => {
            const doc = new DOMParser().parseFromString(input, "text/html");
            return doc.body.textContent || "";
          };
          const decodedValue = decodeHTML(value);
          const cleanedValue = removeHtmlTags(decodedValue);      
          return cleanedValue.length <= 250 || "Description (MS) must be at most 250 characters";
        },        
        // maxLength: 250,
      },
      note: "Description (MS) must not exceed 250 characters"
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_banner_description_man",
      className: "col-span-6",
      type: "text",
      name: "field_banner_description_man",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Mandarin Description is required" },
      validation: { 
        validate: (value: string) => {
          const removeHtmlTags = (input: string) => {
            const doc = new DOMParser().parseFromString(input, "text/html");
            return doc.body.textContent || "";  
          };
          const decodedValue = decodeHTML(value);
          const cleanedValue = removeHtmlTags(decodedValue);      
          return cleanedValue.length <= 250 || "Description (ZH) must be at most 250 characters";
        },        
        // maxLength: 250,
      },
      note: "Description (ZH) must not exceed 250 characters"
    },
    {
      fieldName: "Description Text Color",
      fieldValue: "field_description_color",
      className: "col-span-6",
      type: "text",
      name: "field_description_color",
      formType: "color",
      label: "Description Text Color",
      placeholder: "Enter Description Text Color",
      validation: { required: "Description Text Color is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "field_banner_popup_published",
      className: "col-span-12",
      type: "checkbox",
      name: "field_banner_popup_published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Published",
    },
  ],
};
